const configList = {
  gameList: [
    { game_id: "0", game_name: "名扬传世2003" },
    { game_id: "1", game_name: "飞龙传世热血版" },
    { game_id: "2", game_name: "轩辕传世" },
    { game_id: "3", game_name: "久爱传世绿色版" },
    { game_id: "4", game_name: "与度传世" },
    { game_id: "5", game_name: "盘游剑来传世" },
  ],
  serverList: [
    [
      {
        serverid: "1",
        servername: "1区龙行天下",
      },
      {
        serverid: "2",
        servername: "2区炎黄至尊",
      },
      {
        serverid: "3",
        servername: "3区东成西就",
      },
      {
        serverid: "4",
        servername: "4区潇湘传奇",
      },
      {
        serverid: "5",
        servername: "5区笑傲江湖",
      },
    ],
    [
      {
        serverid: "1",
        servername: "皇图1区",
      },
      {
        serverid: "2",
        servername: "皇图2区",
      },
      {
        serverid: "3",
        servername: "皇图3区",
      },
      {
        serverid: "4",
        servername: "皇图4区",
      },
      {
        serverid: "5",
        servername: "皇图5区",
      },
    ],
    [
      {
        serverid: "1",
        servername: "千佛1区",
      },
      {
        serverid: "2",
        servername: "千佛2区",
      },
      {
        serverid: "3",
        servername: "千佛3区",
      },
      {
        serverid: "4",
        servername: "千佛4区",
      },
      {
        serverid: "5",
        servername: "千佛5区",
      },
    ],
    [
      {
        serverid: "1",
        servername: "辟地1区",
      },
      {
        serverid: "2",
        servername: "辟地2区",
      },
      {
        serverid: "3",
        servername: "辟地3区",
      },
      {
        serverid: "4",
        servername: "辟地4区",
      },
      {
        serverid: "5",
        servername: "辟地5区",
      },
    ],
    [
      {
        serverid: "1",
        servername: "战神1区",
      },
      {
        serverid: "2",
        servername: "战神2区",
      },
      {
        serverid: "3",
        servername: "战神3区",
      },
      {
        serverid: "4",
        servername: "战神4区",
      },
      {
        serverid: "5",
        servername: "战神5区",
      },
    ],
    [
      {
        serverid: "1",
        servername: "名震武林1区",
      },
      {
        serverid: "2",
        servername: "名震武林2区",
      },
      {
        serverid: "3",
        servername: "名震武林3区",
      },
      {
        serverid: "4",
        servername: "名震武林4区",
      },
      {
        serverid: "5",
        servername: "名震武林5区",
      },
    ],
  ],
};

export default configList;
